export default {
    confirm: 'Update Settings',
    documentTypes: {
        acceptance: 'Acceptance Certificate',
        deliveryslip: 'Delivery Slip',
        invoice: 'Invoice',
        order: 'Order', // Different for ConversionSettings
        orderconfirmation: 'Order Confirmation',
        orderslip: 'Order Slip', // Different for ConversionSettings
        quote: 'Quote',
        receipt: 'Receipt',
        timesheet: 'Timesheet',
    },
    helpText:
        'How should the following fields be set when you convert to {{type}}?',
    messagesLabel: 'Messages',
    notesLabel: 'Notes',
    options: {
        copyFromPreset: 'Use Preset',
        copyFromSource: 'Copy From Original',
        leaveBlank: 'Leave Blank',
    },
    title: 'Conversion Settings - Makeleaps',
};
